const constants = {
  apiURL: process.env.REACT_APP_API_URL,
  g2wURL: process.env.REACT_APP_G2W_URL,
  spotifyTokenURL: process.env.REACT_APP_SPOTIFY_TOKEN_URL,
  spotifyApiURL: process.env.REACT_APP_SPOTIFY_API_URL,
  spotifyClientID: process.env.REACT_APP_SPOTIFY_CLIENT_ID,
  spotifySecretKey: process.env.REACT_APP_SPOTIFY_SECRET_KEY,
  crefito2PodcastSpotifyID: process.env.REACT_APP_CREFITO2_PODCAST_SPOTIFY_ID,
  GoogleAnalyticsTrackingId: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID,
};

// console.log("Loaded constants:", constants);

export default constants;
